import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";

export default function Header() {
  return (
    <Container>
      <Navbar expand="lg" variant="light" bg="light">
        <Container>
          <Navbar.Brand href="/">PDF-MERGE APP</Navbar.Brand>
        </Container>
      </Navbar>
    </Container>
  );
}
